export default __webpack_public_path__ + "static/media/dashboard-specimen-icon.8b7506be.svg";